import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { CONTACT, whatsappLink } from "../data/content";

export const Contatti = () => (
  <section
    id="contatti"
    data-testid="contact-section"
    className="relative py-24 sm:py-32 stage-spotlight"
  >
    <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <div className="flex justify-center">
          <SectionLabel>Si Alza il Sipario</SectionLabel>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight mt-6 leading-tight">
          Parliamone{" "}
          <span className="italic text-gold-gradient">a sipario aperto</span>
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-6 text-base sm:text-lg text-[#A19CAE] max-w-xl mx-auto leading-relaxed">
          Niente moduli, niente attese: scrivici su WhatsApp o chiamaci
          direttamente. Rispondiamo in giornata, sette giorni su sette.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
        <Reveal delay={0.22}>
          <a
            data-testid="direct-whatsapp-cta-button"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="card-spotlight group block rounded-2xl border border-[#282338] bg-[#121018] p-8"
          >
            <span className="inline-flex rounded-full bg-[#25D366]/15 border border-[#25D366]/40 p-3.5 text-[#25D366]">
              <MessageCircle size={26} />
            </span>
            <h3 className="font-serif-display text-2xl font-semibold mt-5">
              WhatsApp
            </h3>
            <p className="mt-2 text-sm text-[#A19CAE] leading-relaxed">
              Chat immediata con la direzione artistica. Messaggio precompilato,
              risposta in giornata.
            </p>
            <p className="mt-5 font-mono-label text-sm text-[#E6C594] tracking-wider flex items-center gap-2">
              {CONTACT.phoneDisplay}
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#25D366] animate-pulse" />
            </p>
          </a>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            data-testid="direct-phone-cta-button"
            href={CONTACT.phoneHref}
            className="card-spotlight group block rounded-2xl border border-[#282338] bg-[#121018] p-8"
          >
            <span className="inline-flex rounded-full bg-[#D92B34]/15 border border-[#D92B34]/40 p-3.5 text-[#D92B34]">
              <Phone size={26} />
            </span>
            <h3 className="font-serif-display text-2xl font-semibold mt-5">
              Telefono
            </h3>
            <p className="mt-2 text-sm text-[#A19CAE] leading-relaxed">
              Per booking urgenti e reperibilità eventi: chiamaci, anche nei
              weekend e in tournée.
            </p>
            <p className="mt-5 font-mono-label text-sm text-[#E6C594] tracking-wider">
              {CONTACT.phoneDisplay}
            </p>
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.38}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-[#A19CAE]">
          <a
            data-testid="contact-email-link"
            href={`mailto:${CONTACT.email}`}
            className="flex items-center gap-2 hover:text-[#E6C594] transition-colors duration-300"
          >
            <Mail size={16} /> {CONTACT.email}
          </a>
          <span className="hidden sm:block h-4 w-px bg-[#282338]" />
          <p data-testid="contact-location" className="flex items-center gap-2">
            <MapPin size={16} /> {CONTACT.city}
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
